import { createReducer } from '@reduxjs/toolkit'

import { AuthActionTypes } from '@store/auth'
import {
  fetchSnapMetrics,
  fetchSnapMetricsError,
  fetchSnapMetricsSuccess,
} from '@store/postCampaignReport/snapMetrics/actions'
import { indexById } from '@utils/groupBy'
import { ISnapMetrics, ISnapMetricsState } from './types'

const initialState: ISnapMetricsState = {
  isFetching: false,
  errors: undefined,
  snapMetricsById: {},
  snapMetricIdsByCampaignId: {},
  snapMetricsSummaryByCampaignId: {},
}

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchSnapMetrics, (state) => {
      state.isFetching = true
    })
    .addCase(fetchSnapMetricsSuccess, (state, { payload }) => {
      const { campaignId, metrics } = payload

      state.errors = undefined
      state.isFetching = false

      state.snapMetricsById = {
        ...state.snapMetricsById,
        ...indexById(metrics.items, state.snapMetricsById, 'submission_id'),
      }

      state.snapMetricsSummaryByCampaignId = {
        ...state.snapMetricsSummaryByCampaignId,
        [campaignId]: metrics.metadata,
      }

      state.snapMetricIdsByCampaignId = {
        ...state.snapMetricIdsByCampaignId,
        [campaignId]: metrics.items.map((metric: ISnapMetrics) => metric.submission_id),
      }
    })
    .addCase(fetchSnapMetricsError, (state, { payload }) => {
      state.isFetching = false
      state.errors = payload
    })
    .addMatcher(
      (action) => action.type === AuthActionTypes.SIGNOUT_SUCCESS,
      () => initialState,
    )
})

export { reducer as snapMetricsReducer }
